import { render, staticRenderFns } from "./OverviewNav.vue?vue&type=template&id=785f3515&"
import script from "./OverviewNav.vue?vue&type=script&lang=js&"
export * from "./OverviewNav.vue?vue&type=script&lang=js&"
import style0 from "./OverviewNav.vue?vue&type=style&index=0&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports